import { type AuthenticatedUserResponse } from '@govinity/validation';
import { create } from 'zustand';

interface AuthProperties {
  user: AuthenticatedUserResponse | null;
}

interface AuthState extends AuthProperties {
  login: (user: AuthenticatedUserResponse) => void;
  logout: () => void;
}

const initialProperties: AuthProperties = {
  user: null,
};

export const useAuthStore = create<AuthState>((set) => ({
  ...initialProperties,
  login: (user) => set({ user }),
  logout: () => set({ ...initialProperties }),
}));
